// Module
var code = "<div class=\"property-container sortingItem\"> <select data-bind=\"options: _fields, optionsText: 'FullName', value: _selectedField\" class=\"form-control\"></select> <span class=\"inputCheckbox\"><input data-bind=\"checked: _orderByDescending\" type=\"checkbox\">Desc</span> </div>";
// Exports
export default code;